/* Panashe theme.js — no dependencies */
(function () {
  'use strict';

  var P = window.Panashe || {};
  var overlay = document.querySelector('[data-overlay]');
  var openDrawerEl = null;
  var lastFocus = null;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || P.moneyFormat || '₹{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return cents;
    function delimit(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (match[1]) {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  P.formatMoney = formatMoney;

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    }
    document.body.classList.add('is-locked');
    openDrawerEl = el;
    var focusable = el.querySelector('[data-autofocus], button, a, input');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 80);
  }
  function closeDrawer(silent) {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open');
    openDrawerEl.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { if (!openDrawerEl) overlay.hidden = true; }, 350);
    }
    document.body.classList.remove('is-locked');
    if (!silent && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  P.openDrawer = openDrawer;
  P.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-open-drawer'));
      return;
    }
    if (e.target.closest('[data-close-drawer]') || e.target === overlay) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Dialogs (size guide, lightbox) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-dialog]');
    if (t) {
      var d = document.getElementById(t.getAttribute('data-open-dialog'));
      if (d && d.showModal) {
        e.preventDefault();
        d.showModal();
        var target = t.getAttribute('data-scroll-to');
        if (target) {
          var img = d.querySelector('[data-lightbox-item="' + target + '"]');
          if (img) img.scrollIntoView({ block: 'start' });
        }
      }
      return;
    }
    var c = e.target.closest('[data-close-dialog]');
    if (c) {
      var dlg = c.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Search overlay ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-open-search]');
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    if (s) {
      e.preventDefault();
      modal.classList.add('is-open');
      var input = modal.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 120);
      return;
    }
    if (e.target.closest('[data-close-search]')) {
      e.preventDefault();
      modal.classList.remove('is-open');
    }
  });
  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('[data-search-modal].is-open');
    if (modal && e.key === 'Escape') modal.classList.remove('is-open');
  });

  /* ---------- Cart ---------- */
  function cartDrawer() { return document.getElementById('CartDrawer'); }

  function renderCartDrawer(html) {
    var drawer = cartDrawer();
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var current = drawer.querySelector('[data-cart-inner]');
    if (fresh && current) current.replaceWith(fresh);
    var countEl = doc.querySelector('[data-cart-count-source]');
    if (countEl) updateCount(parseInt(countEl.getAttribute('data-cart-count-source'), 10));
  }
  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });
  }

  function setBusy(on) {
    var d = cartDrawer();
    if (d) d.classList.toggle('is-busy', !!on);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    if (!cartDrawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(P.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          if (errorEl) { errorEl.textContent = data.description || data.message; errorEl.hidden = false; }
          return;
        }
        if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
        openDrawer('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
  });

  function changeLine(line, qty) {
    setBusy(true);
    return fetch(P.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
        else if (data.item_count != null) updateCount(data.item_count);
      })
      .finally(function () { setBusy(false); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b || !b.closest('#CartDrawer')) return;
    e.preventDefault();
    changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-qty'), 10));
  });

  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    if (!wrap || wrap.closest('#CartDrawer')) return;
    var input = wrap.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    var next = Math.max(parseInt(input.min || '0', 10), v + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (err) { return; }
    var picker = root.querySelector('[data-variant-picker]');
    var idInputs = root.querySelectorAll('[data-variant-id]');
    var priceEls = root.querySelectorAll('[data-product-price]');
    var buttons = root.querySelectorAll('[data-add-button]');
    var stockEl = root.querySelector('[data-stock]');
    var threshold = parseInt(root.getAttribute('data-low-stock') || '3', 10);

    function selectedOptions() {
      return Array.prototype.map.call(picker.querySelectorAll('[data-option-group]'), function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      picker.querySelectorAll('[data-option-group]').forEach(function (g, gi) {
        g.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var match = findVariant(test);
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
        var label = g.querySelector('[data-option-value]');
        if (label) label.textContent = opts[gi] || '';
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      buttons.forEach(function (b) {
        var label = b.querySelector('[data-add-label]') || b;
        if (!v) {
          b.disabled = true;
          label.textContent = 'Unavailable';
        } else if (!v.available) {
          b.disabled = true;
          label.textContent = 'Sold out';
        } else {
          b.disabled = false;
          label.textContent = b.getAttribute('data-add-text') || 'Add to bag';
        }
      });
      if (!v) return;
      idInputs.forEach(function (i) { i.value = v.id; });
      priceEls.forEach(function (el) {
        var html = v.compare_at_price > v.price
          ? '<span class="price__sale">' + formatMoney(v.price) + '</span><span class="price__compare">' + formatMoney(v.compare_at_price) + '</span>'
          : '<span>' + formatMoney(v.price) + '</span>';
        el.innerHTML = '<span class="price">' + html + '</span>';
      });
      if (stockEl) {
        var cls = 'product__stock';
        var text;
        if (!v.available) { cls += ' product__stock--out'; text = 'Sold out — this piece will return'; }
        else if (v.tracked && v.qty > 0 && v.qty <= threshold) { cls += ' product__stock--low'; text = 'Only ' + v.qty + ' left in this size'; }
        else { text = 'In stock, ready to ship'; }
        stockEl.className = cls;
        stockEl.innerHTML = '<span class="dot"></span><span>' + text + '</span>';
      }
      if (v.media_id) {
        var media = root.querySelector('[data-media-id="' + v.media_id + '"]');
        var gallery = root.querySelector('[data-gallery]');
        if (media && gallery) {
          if (window.matchMedia('(max-width: 989px)').matches) {
            gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          } else if (gallery.firstElementChild !== media) {
            gallery.insertBefore(media, gallery.firstElementChild);
          }
        }
      }
      if (root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', update);
      markAvailability(selectedOptions());
    }
  });

  /* ---------- Mobile gallery dots ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var dots = gallery.parentElement.querySelectorAll('[data-gallery-dots] span');
    if (!dots.length || !('IntersectionObserver' in window)) return;
    var items = gallery.querySelectorAll('.product__media-item');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
          var idx = Array.prototype.indexOf.call(items, entry.target);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
      });
    }, { root: gallery, threshold: [0.6] });
    items.forEach(function (i) { io.observe(i); });
  });

  /* ---------- Sticky add to cart ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainBuy = document.querySelector('[data-main-buy]');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(mainBuy);
  }

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort]');
    if (!s) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          rio.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { rio.observe(el); });
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('#CartDrawer')) closeDrawer(true);
  });
})();
